module.exports = __webpack_public_path__ + "static/media/empty-company-state.e497de75.svg";